import { useUrlForPageId } from '../../../../../utils/useUrlForPageId';
import { PassengersPageId } from '../../../../app/pages/domain/constants/PageId';
import { IEnrichedFlight } from '../../../shared/flight/domain/models/IEnrichedFlight';

export function useFlightDetailUrl(flight: IEnrichedFlight) {
	const {
		scheduledDate,
		codeShareFlightNumber,
		viaAirport,
		arrivalAirport,
		departureAirport,
		arrival,
	} = flight;

	const pathname = useUrlForPageId(PassengersPageId.FlightDetail);

	return {
		pathname,
		query: {
			scheduledDate,
			codeShareFlightNumber,
			viaAirport,
			arrivalAirport,
			departureAirport,
			arrival,
		},
	};
}
